import { OutputAttributes, OutputLifecycleSurveyTrigger } from '~/gql/graphql';

const lifecycleSurveyTriggerTransformer = (data: OutputLifecycleSurveyTrigger) => {
  const attributes = {};
  if (data.audienceType === 'ATTRIBUTE_BASED' && !!data?.attributeAudience?.length) {
    (data.attributeAudience as OutputAttributes[]).forEach((attr) => {
      const prevValue = attributes[attr.attributeId] || [];
      attributes[attr.attributeId] = [...prevValue, attr.attributeValue];
    });
  }

  return {
    ...data,
    survey: {
      id: data.surveyId,
    },
    lifecycleSurveyType: {
      id: data.lifecycleSurveyTypeId,
    },
    triggerAttribute: {
      id: data.triggerAttributeId,
    },
    adminApprovers: data.adminApprovers?.map((approver) => ({
      // @ts-ignore @TODO Epic WT-21600
      id: approver.userId,
    })),
    superAdminApprovers: data.superAdminApprovers?.map((approver) => ({
      // @ts-ignore @TODO Epic WT-21600
      id: approver.userId,
    })),
    attributes,
    status: data.status,
  };
};

export { lifecycleSurveyTriggerTransformer };
